import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderOriginal } from "posthog-js/react";

import {
  POSTHOG_API_KEY,
  POSTHOG_OPTIONS,
} from "context/posthog/posthogConfig";

import type { ReactNode } from "react";

interface PostHogProviderProps {
  children: ReactNode;
}

window._fuzebox = window._fuzebox || {};
window._fuzebox.processConsent = () => {
  posthog.set_config({ persistence: "localStorage+cookie" });
};

export function PostHogProvider({ children }: PostHogProviderProps) {
  return (
    <PostHogProviderOriginal
      apiKey={POSTHOG_API_KEY ?? ""}
      options={POSTHOG_OPTIONS}
    >
      {children}
    </PostHogProviderOriginal>
  );
}
